function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 3.625V11.875C14 12.0859 13.8828 12.2969 13.6719 12.3906L10.7656 13.75C10.4609 13.8906 10.1094 13.9141 9.78125 13.8203L5.79688 12.4844L2.79688 13.8906C2.63281 13.9609 2.42188 13.9609 2.25781 13.8438C2.09375 13.75 2 13.5625 2 13.375V5.125C2 4.91406 2.11719 4.70312 2.32812 4.60938L5.23438 3.25C5.53906 3.10938 5.89062 3.08594 6.21875 3.17969L10.2734 4.5625L13.1797 3.13281C13.3672 3.03906 13.5781 3.03906 13.7422 3.15625C13.9062 3.25 14 3.4375 14 3.625ZM5.375 4.42188L3.125 5.47656V12.4844L5.375 11.4297V4.42188ZM6.5 11.5234L9.5 12.5312V5.5L6.5 4.46875V11.5234ZM10.625 5.64062V12.5781L12.875 11.5234V4.53906L10.625 5.64062Z",
  fill: "#636766"
});

function SvgWhitelistingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelistingIcon);
export default __webpack_public_path__ + "static/media/whitelisting-icon.954ce4ed.svg";
export { ForwardRef as ReactComponent };